import { tr } from './i18n/i18n.ts';
import { isNative } from './platform.ts';

/**
 * Var AutoDay-servern finns.
 *  - Webb: samma ursprung som sidan (tom bas = relativa /api-anrop). En avsiktligt separat API-bas kan
 *    byggas in med VITE_AUTODAY_API_BASE och respekteras.
 *  - Native: telefonens "localhost" är inte utvecklingsdatorn. Utan VITE_AUTODAY_API_BASE finns ingen
 *    server – appen säger det i stället för att hitta på en adress.
 */
const BUILT_IN = ((import.meta.env['VITE_AUTODAY_API_BASE'] as string | undefined) ?? '').trim().replace(/\/+$/, '');

export function defaultApiBase(): string | null {
  if (BUILT_IN) return BUILT_IN;
  return isNative() ? null : '';
}

/** Absolut ursprung för en API-bas ('' = sidans eget ursprung). */
export function originOf(base: string): string {
  return base ? new URL(base).origin : location.origin;
}

/** Kort, läsbar destination för gränssnittet, t.ex. "localhost:8787". */
export function hostOf(base: string): string {
  return base ? new URL(base).host : location.host;
}

/**
 * Validerar en manuellt angiven server (Egen server / avancerat). Endast https, utom http för
 * localhost/127.0.0.1 vid utveckling. Returnerar normaliserat ursprung.
 */
export function normalizeServerInput(input: string): string {
  const raw = input.trim();
  let u: URL;
  try {
    u = new URL(raw);
  } catch {
    throw new Error(tr('Ange en fullständig adress, t.ex. https://autoday.example.se', 'Enter a complete address, e.g. https://autoday.example.com'));
  }
  if (u.username || u.password) throw new Error(tr('Adressen får inte innehålla användarnamn eller lösenord.', 'The address must not contain a user name or password.'));
  const local = u.hostname === 'localhost' || u.hostname === '127.0.0.1';
  if (u.protocol !== 'https:' && !(u.protocol === 'http:' && local)) throw new Error(tr('Servern måste nås via https:// (http tillåts bara för localhost vid utveckling).', 'The server must be reached via https:// (http is only allowed for localhost during development).'));
  return u.origin;
}
